import { useGraphQLQuery } from '@betterment/graphql';

import { SignablePackageQueryResult } from './data';
import { QuerySignablePackageDocument, QuerySignablePackageQuery } from './graphql/query.signable_package.generated';

export const useSignablePackageQuery = (signablePackageId: string): SignablePackageQueryResult => {
  const { data: rawData } = useGraphQLQuery(QuerySignablePackageDocument, {
    throwOnError: true,
    variables: { signablePackageId },
  });
  const data = rawData as QuerySignablePackageQuery | undefined;

  const isLoading = !data;

  return {
    isLoading,
    signablePackage: data?.signablePackage,
  };
};
